/**
 * Get the nth rules explaination.
 */
export function getExplaination(expression) {
    let ex = expression.replace(/\s/g, '').replace('0n+', '').replace('+0', '')

    if (ex === 'odd') {
        return 'Matches all odd numbered items'
    }

    if (ex === 'even') {
        return 'Matches all even numbered items'
    }

    if (ex === '0' || ex === '0n' || ex === '+0n' || ex.match(/^-\d*n$/g)) {
        return 'Matches no items'
    }

    if (ex === 'n' || ex === '1n') {
        return 'Matches every item'
    }

    if (ex.match(/\dn$/g)) {
        return `Matches every ${getOrdinal(ex)} item`
    }

    if (ex.match(/^\+?\d*$/g)) {
        return `Matches only the ${getOrdinal(ex)} item`
    }

    if (ex.includes('+')) {
        const [every, start] = ex.split('+')
        
        let negative = ex.startsWith('-') ? ' and working backwards' : ''

        return `Matches every ${getOrdinal(every)} item, starting from the ${getOrdinal(start)} item${negative}`
    }

    if (ex.includes('-')) {
        const [every, start] = ex.split('-')
        
        return `Matches every ${getOrdinal(every)} item, starting from -${start}`
    }

    return null
}

/**
 * Get number ordinal.
 * 
 * i.e. 1st, 2nd, 3rd
 */
export function getOrdinal(n) {
    if (!n || n === 'n' || n === '-n' || n === '1n') return ''

    let val = n.replace('n', '').replace('-', '').replace('+', '')

    const v = val % 100
    const s = ['th', 'st', 'nd', 'rd']

    const suffix = (s[(v - 20) % 10] || s[v] || s[0])

    return val + suffix
}
